import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { changePassword, getUserById } from "../../actions/UserActions";
import { loadPasswordSettingsById } from "../../actions/OrganizationActions";
import Logo from "../common/Logo.jsx";
import ChangePasswordSuccess from "./ChangePasswordSuccess";
import ChangePasswordComponent from "../../components/User/ChangePasswordComponent";
import PasswordValidationUserData, { createPasswordValidationUserDataFromUser } from "../../entities/PasswordValidationUserData";

export class ChangePasswordPage extends Component {
    constructor (props) {
        super(props);

        this.state = {
            userId: window.UserId,
            site: window.Site,
            passwordChanged: props.passwordChanged
        };

        this.onSave = this.onSave.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount() {
        import('./_passwordStyles.scss');
        const orgId = window.OrgId;
        const userId = window.UserId;
        this.props.loadSettingsById(orgId);
        this.props.loadPasswordValidationUserDataById(userId);
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.passwordChanged !== this.props.passwordChanged) {
            this.setState({ passwordChanged: nextProps.passwordChanged });
        }
    }

    onClose () {
        this.setState({ passwordChanged: false });
        window.top.close();
        window.close();
    }

    onSave (newPassword, password) {
        this.props.changePassword(newPassword, password, this.state.userId);
    }

    render () {
        if (this.props.passwordValidationRules == null)
            return null;

        const passwordValidationUserData = createPasswordValidationUserDataFromUser(this.props.user);
        return (
            <div id="resetPasswordPage">
                <div className="row">
                    <div className="col-md-3">
                        <Logo />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 col-md-offset-4">
                        <h2>Change Password</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 col-md-offset-4">
                        <ChangePasswordSuccess changed = {this.state.passwordChanged} onClose={this.onClose} />

                        <ChangePasswordComponent
                            onSave={this.onSave}
                            errorSummary="Unable to change password"
                            passwordValidationUserData={passwordValidationUserData}
                            passwordValidationRules = {this.props.passwordValidationRules}
                            newPasswordConfirm = {this.state.newPasswordConfirm}
                            serverFailureMessage = {this.props.serverFailureMessage}
                        />
                    </div>
                </div>
            </div>);
    }
}

ChangePasswordPage.defaultProps = {
    changePassword: () => {},
    passwordChanged: false
};

ChangePasswordPage.propTypes = {
    changePassword: PropTypes.func,
    loadSettingsById: PropTypes.func,
    loadPasswordValidationUserDataById: PropTypes.func,
    passwordChanged: PropTypes.bool,
    user: PropTypes.object
};

const mapStateToProps = state => ({
    passwordValidationRules: state.userState.passwordValidationRules,
    passwordChanged: state.userState.passwordChanged,
    serverFailureMessage: state.userState.serverFailureMessage,
    user: state.userState.user
});

const mapDispatchToProps = (dispatch) => {
    return ({
        changePassword: (newPassword, currentPassword, userId) => dispatch(changePassword(newPassword, currentPassword, userId)),
        loadSettingsById: (siteId) => dispatch(loadPasswordSettingsById(siteId)),
        loadPasswordValidationUserDataById: (userId) => dispatch(getUserById(userId))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordPage);
